import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchkampeerplaatsenMetFilter, bulkSchakelenMeters, bulkStatusMeters } from "../../Reducers/actions";
import { message } from "../../../../Reducers/loading/actions";
import Loading from "../../../../Components/loading/load";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";

function MeterInstellen({ kampeerplaatsen, fetchkampeerplaatsenMetFilter, bulkSchakelenMeters, bulkStatusMeters, message }) {
  const [load, setLoad] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectedSensors, setSelectedSensors] = useState([]);
  const [bulkLoading, setBulkLoading] = useState(false);

  const loadData = (filterValue) => {
    setLoad(false);
    fetchkampeerplaatsenMetFilter(filterValue || undefined).then(() => {
      setLoad(true);
      setSelectedSensors([]);
    });
  };

  useEffect(() => {
    loadData(filter);
  }, []);

  const handleFilterChange = (e) => {
    const newFilter = e.target.value;
    setFilter(newFilter);
    loadData(newFilter);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allSensorIds = kampeerplaatsen
        .filter((p) => p.sensor && p.sensor._id)
        .map((p) => p.sensor._id);
      setSelectedSensors(allSensorIds);
    } else {
      setSelectedSensors([]);
    }
  };

  const handleSelectOne = (sensorId) => {
    if (selectedSensors.includes(sensorId)) {
      setSelectedSensors(selectedSensors.filter((id) => id !== sensorId));
    } else {
      setSelectedSensors([...selectedSensors, sensorId]);
    }
  };

  const handleBulkSchakelen = async (schakelen) => {
    if (selectedSensors.length === 0) {
      message(3000, "warning", "Selecteer eerst meters om te schakelen");
      return;
    }
    setBulkLoading(true);
    try {
      const result = await bulkSchakelenMeters(selectedSensors, schakelen);
      if (result?.payload?.message) {
        message(5000, "success", result.payload.message);
      }
      setTimeout(() => loadData(filter), 2000);
    } catch (err) {
      message(3000, "danger", "Er is een fout opgetreden");
    }
    setBulkLoading(false);
  };

  const handleBulkStatus = async () => {
    if (selectedSensors.length === 0) {
      message(3000, "warning", "Selecteer eerst meters om status op te halen");
      return;
    }
    setBulkLoading(true);
    try {
      const result = await bulkStatusMeters(selectedSensors);
      if (result?.payload?.message) {
        message(5000, "success", result.payload.message);
      }
      setTimeout(() => loadData(filter), 5000);
    } catch (err) {
      message(3000, "danger", "Er is een fout opgetreden");
    }
    setBulkLoading(false);
  };

  const { SearchBar } = Search;

  const selectColumn = {
    dataField: "select",
    text: (
      <input
        type="checkbox"
        onChange={handleSelectAll}
        checked={
          kampeerplaatsen.filter((p) => p.sensor?._id).length > 0 &&
          selectedSensors.length === kampeerplaatsen.filter((p) => p.sensor?._id).length
        }
      />
    ),
    formatter: (cellContent, row) => {
      if (!row.sensor?._id) return null;
      return (
        <input
          type="checkbox"
          checked={selectedSensors.includes(row.sensor._id)}
          onChange={() => handleSelectOne(row.sensor._id)}
        />
      );
    },
    headerStyle: { width: "40px" },
  };

  const columns = [
    selectColumn,
    {
      dataField: "naam",
      text: "Plaats",
      formatter: (cellContent) => (cellContent?.NL ? cellContent.NL : cellContent),
    },
    {
      dataField: "sensor.lastcheck",
      text: "Laatste data",
      formatter: (cellContent, row) => (row?.sensor?.lastcheck ? moment(row.sensor.lastcheck).fromNow() : "-"),
    },
    {
      dataField: "sensor.lastvalue",
      text: "Meterstand",
      formatter: (cellContent, row) => (row?.sensor?.lastvalue >= 0 ? Number(row.sensor.lastvalue).toFixed(2) : "-"),
    },
    {
      dataField: "sensor.electra.ingeschakeld",
      text: "Status",
      formatter: (cellContent, row) => {
        if (!row.sensor) return <span className="badge bg-secondary">Geen meter</span>;
        return row.sensor?.electra?.ingeschakeld ? (
          <span className="badge bg-success">Ingeschakeld</span>
        ) : (
          <span className="badge bg-danger">Uitgeschakeld</span>
        );
      },
    },
    {
      dataField: "sensor.boeking",
      text: "Reservering",
      formatter: (cellContent, row) => {
        if (row.sensor?.boeking?.boekingId) {
          return <span className="badge bg-info">Gereserveerd</span>;
        }
        return <span className="badge bg-secondary">Vrij</span>;
      },
    },
    {
      text: "Acties",
      dataField: "acties",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <Link className="btn btn-warning btn-sm" to={{ pathname: "/standplaatsen/kampeerplaatsen/monteur/" + row._id }}>
          Instellen
        </Link>
      ),
    },
  ];

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Meters Instellen</h3>
      </div>
      <div className="box-body">
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Filter op reservering</label>
            <select className="form-control" value={filter} onChange={handleFilterChange}>
              <option value="">Alle plaatsen</option>
              <option value="ja">Met reservering</option>
              <option value="nee">Zonder reservering</option>
            </select>
          </div>
          <div className="col-md-8 d-flex align-items-end gap-2">
            <button
              className="btn btn-success"
              onClick={() => handleBulkSchakelen(true)}
              disabled={bulkLoading || selectedSensors.length === 0}
            >
              <i className="fas fa-plug me-2"></i>
              Inschakelen ({selectedSensors.length})
            </button>
            <button
              className="btn btn-danger"
              onClick={() => handleBulkSchakelen(false)}
              disabled={bulkLoading || selectedSensors.length === 0}
            >
              <i className="fas fa-power-off me-2"></i>
              Uitschakelen ({selectedSensors.length})
            </button>
            <button
              className="btn btn-info"
              onClick={handleBulkStatus}
              disabled={bulkLoading || selectedSensors.length === 0}
            >
              <i className="fas fa-sync me-2"></i>
              Status ophalen ({selectedSensors.length})
            </button>
          </div>
        </div>

        <Loading loadings={load} />

        {load && (
          <ToolkitProvider keyField="_id" data={kampeerplaatsen} columns={columns} search={{ searchFormatted: true }}>
            {(props) => (
              <div>
                <SearchBar placeholder="Zoeken op naam..." {...props.searchProps} />
                <hr />
                <BootstrapTable
                  wrapperClasses="table-responsive-md"
                  pagination={paginationFactory({ sizePerPage: 20 })}
                  {...props.baseProps}
                />
              </div>
            )}
          </ToolkitProvider>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.auth.user, kampeerplaatsen: state.standplaatsen.kampeerplaatsen };
}

export default connect(mapStateToProps, { fetchkampeerplaatsenMetFilter, bulkSchakelenMeters, bulkStatusMeters, message })(MeterInstellen);
